import { IDeductionActivityRepository, IExportDeductionActivityRepositoryRequest } from "@/core/repositories/deduction";

export class ExportDeductionActivityUseCase {
  constructor(private readonly deductionActivityRepository: IDeductionActivityRepository) {}

  async execute(body: IExportDeductionActivityRepositoryRequest): Promise<{ signedUrl: string; success: boolean }> {
    return this.deductionActivityRepository.exportActivities(body);
  }
}
